import { createListFilters, IOption } from 'app/components'
import { TipoFornecedor } from '../../core/_models'

export type FornecedoresFilters = {
  nome: string
  tipo?: IOption<TipoFornecedor>
  ativo?: IOption<boolean>
}

export const { ListFiltersProvider, useListFilters } = createListFilters<FornecedoresFilters>({
  nome: '',
  tipo: undefined,
  ativo: undefined,
})
